<template>
  <div
    class="nurition-info"
    style="margin-top: -16px"
  >
    <div v-if="!isApp" class="info-header">
      <i
        @click="redirectToPreviousPage()"
        class="jfi-back-v2 back-icon mr20 fs-16"
      ></i>
      <span class="info-heading">Nutritional Information</span>
    </div>
    <div class="info-content-v2 plr12 pb16">
    <div 
      class="panel" 
      :style="getWrapperHeight()"
      >
      <div style="text-align: center">
          <div
            v-for="(item, index) in imgData"
            :key="index"
            class="wrap-ni"
          >
            <lazy-image
              class="nutritional-img"
              :alt="item.alt"
              :src="staticImgBaseUrl + item.imageUrl"
              :src-placeholder="getPlaceHolderImg"
              :intersection-options="{ threshold: 0.1 }"
            />
          </div>

      </div>
    </div>

    </div>
  </div>
</template>

<script setup>
  import LazyImage from "./LazyImage.vue";
</script>
<script>
import Utility from "../helpers/utility";
import LocalStorageFunc from "../helpers/localStorageFunc";
import {
  VWO_NEXTGEN_HOMEPAGE_EXPERIMENT,
  VWO_NEXTGEN_EXPERIMENT_VARIANTS,
} from "../config/vwoKeys";
import {
  projectBasePathWithFolder,
  staticImgBaseUrl,
} from "../config/apiEndpoints";
import PageNames from "../config/pageNames";
import NutritionalInfoImagesData from "../assets/FallbackData/NutritionalInfoImagesData.json";
import { keyMapsGetter} from "../helpers/storeKeys";

export default {
  name: "NutritionInfo",
  props: ["moduleProps"],
  components: {
    //  
  },
  data() {
    return {
      staticImgBaseUrl: staticImgBaseUrl,
      imgData: [],
      isApp: false,
    };
  },
  mounted() {
    const elePgWrapper = document.getElementsByClassName("pg-wrapper")[0];
    const list = elePgWrapper.classList;
    const assetName = Utility.getQueryFromUrl()["assetName"];
    if(assetName === "app") {
      this.isApp = true;
    }

    if (elePgWrapper && list) {
      list.add("pb0");
    }

    this.imgData = (NutritionalInfoImagesData?.data) ? (NutritionalInfoImagesData?.data) : [];
  },
  unmounted() {
    const elePgWrapper = document.getElementsByClassName("pg-wrapper")[0];
    const list = elePgWrapper?.classList;

    if (elePgWrapper && list) {
      list.remove("pb0");
    }
  },
  methods: {
    getWrapperHeight() {
      let imgCount = this.imgData.length;
      let _ = {
        maxHeight: (imgCount * 1118)+'px',
      };
      return _;
    },
    isSeparateMenuVariant() {
      let exp = this.$store.state.Config.vwoExperiments;
      if(
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ==
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_U ||
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ==
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_W ||
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ==
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_X ||
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ==
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_Y
      ) {
        return true;
      } else {
        return false;
      }
    },
    redirectToPreviousPage() {
      let linkRewrite = "/landing/";
      let previousLinkRewrite =
        LocalStorageFunc.getSessionStorageKey("previousLinkRewrite") || "";
      if (
        previousLinkRewrite === PageNames.NEXTGEN_LINKREWRITE_HOME &&
        !this.isSeparateMenuVariant()
      ) {
        linkRewrite = "/home/";
      }

      window.location.href =
        projectBasePathWithFolder +
        linkRewrite +
        LocalStorageFunc.storeId() +
        Utility.getUrlQueryString();
    },
    getPlaceHolderImg(){
      const img =  this.$store.getters[keyMapsGetter.GET_PLACE_HOLDER_IMAGE]?.square;
      const fallBack = staticImgBaseUrl + '/images/global/default-product-img-lg.png'
      return img || fallBack;
    }
  },
  computed: {
    
  }
};
</script>

<style></style>
